/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect } from 'react';
import { useLazyGetUserDetailsQuery } from '@api/userDetails';
import { useDispatch } from 'react-redux';

import { setUserDetails } from '@components/AuthGuard/slice';
import UserAuth from '@services/auth';
import { setCombineFeatureFlag } from '@store/AppSlice';
import { sendAmplitudeData } from '@utils/amplitude';
import { SIGNED_IN } from '@constants/eventNames';

const useUserDetails = () => {
  const [getUser, { data: userData, isLoading }] = useLazyGetUserDetailsQuery();

  const dispatch = useDispatch();

  // Initiate feature flag status
  useEffect(() => {
    dispatch(
      setCombineFeatureFlag(`${process.env.REACT_APP_COMBINE_FLAG}` === 'TRUE')
    );
  }, []);

  const getUserDetails = async (userId: string) => {
    try {
      const response = await getUser(userId).unwrap();

      if (response) {
        if (UserAuth.isUserSignedIn) {
          const currentPlan = response?.plan;
          const isTrial = response?.is_trial;

          sendAmplitudeData(SIGNED_IN, {
            current_plan: `${currentPlan} ${isTrial ? '_TRIAL' : ''}`,
            Sign_in_channel: UserAuth.isUserSignedIn
          });

          UserAuth.removeIsUserSignedIn();
        }
        dispatch(setUserDetails(response));
        UserAuth.setUserDetails(response);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return { getUserDetails, isLoading };
};

export default useUserDetails;
